/**
 * Use:
 * env === 'development'
 * ... for only doing things locally
 *
 * Use:
 * role === 'owner'
 * ... for only showing things for account owners
 *
 * You can use other values to target specific environments or roles
 */

// 08b6bdef-c3c0-4f42-8015-3b1029a69692

export default ({env, role, account}) => ({
    settings: role === 'owner',
    settingsSocial: env === 'development',
    settingsTeam: role === 'owner',

    projectsPage: true,
    textBgColour: true,
    elementArrangement: true,
});
